import {IconButton, styled} from "@mui/material";

const SwitchButton = styled(IconButton)(({theme}) => ({
    color: theme.palette.text.primary,
    [theme.breakpoints.down('lg')]: {
        width: "100%",
        borderRadius: 4,
        background: theme.palette.primary.dark,
        color: "#fff",
        "&:hover": {
            background: theme.palette.background.default
        }
    }
}));
export default SwitchButton;